import React, {useEffect} from "react";
import StepIndicator from "../subComponent/step-indicator/StepIndicator";
import {SuccessAlertComponent} from "../odsCalloutBox/SuccessAlertComponent";
import {FormSectionElements, ProgramContainer} from "../../entities/formTemplateDataType";
import {EmailButtonComponent} from "../subComponent/EmailButtonComponent";
import axios from "axios";
import {Heading5} from "../../theme";
import {WarningAlertComponent} from "../odsCalloutBox/WarningAlertComponent";
import FeedbackComponent from "../subComponent/FeedbackComponent";
import {
    ReactComponent as AlertIcon
} from '../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-alert-information.svg';
import {FeedbackStatus} from "../../entities/Constants";
import {normalizeUrl} from "../../utilities/URLUtils";
import TrackPageView from "../../utilities/TrackPageView";
import createAccount from "../../../public/assets/images/create-account.png";
import renewalReminders from "../../../public/assets/images/renewal-reminders.png";
import moreServices from "../../../public/assets/images/more-services.png";
import {styled} from "styled-components";
import DataUtils from "../../utilities/DataUtils";
import { getEnvVar } from "../../config/RuntimeConfig";


const Divider = styled.div`
    width: 100%;
    height: 0;
    border-top: 3px solid #D1D1D1;
    opacity: 1;
    transform: rotate(0deg);
    margin: 50px auto;
`;

const CONTENT = {
    en: {
        emailTitle: "Send transaction receipt to this email address:",
        emailDescription: "Your email address will only be used to send you a transaction receipt and will not be retained.",

        backToHome: "Back to home",
        backToOntario: "Back to Ontario.ca",

        alertTitle: "The child health card has been renewed",
        confirmationReceiptBody: "A confirmation receipt will be sent to your inbox.",
        confirmationReceiptBodyForUser: "An email confirmation with your receipt was sent to {{email}}",

        technicalIssueWarning: "Due to a technical issue, we were unable to generate your downloadable receipt. Please keep a record of your order ID and contact ServiceOntario if you do not receive the health card in 4-6 weeks.",

        pageTitle: "order-confirmation",
        saveReceiptTitle: "Save your confirmation receipt",

        orderIdLabel: "Order ID: ",

        confirmationTextGuest: "To continue using the current child health card, you can download a copy of this confirmation or send a copy to your email below.",
        confirmationTextUser: "A confirmation receipt has been sent to your account inbox. To keep a record of your renewal, you can download a copy of this confirmation. This can be used with the current child health card until the new one arrives.",

        downloadPdfButton: "Download PDF confirmation",

        importantNoticeGuest: "IMPORTANT: Check your downloaded files before closing this screen. You will not be able to access your confirmation here again.",
        importantNoticeUser: "IMPORTANT: Check your downloaded files before closing this screen. You will not be able to access your confirmation here again.",

        whatToDoNext: "What to do next:",
        step1: "If you do not print and/or download your document now, you will need to visit a {{ServiceOntarioLink}} to request a copy.",
        step2: "A screenshot of this page is not your temporary document and cannot be used as proof of renewal.",
        step3: "You must carry the temporary document and receipt along with your child’s existing health card until the new child health card arrives in the mail.",
        step4: "The new child health card will arrive in the mail in 4-6 weeks. Once you receive your child’s health card, you must destroy the old child health card. You will also need to destroy your printed temporary document.",

        continueUsingCard: "Please continue to use your child's existing health card until the process is completed. If the application is successful, the renewed card will be mailed to you in approximately 4 to 6 weeks. If you do not receive your card within 6 weeks of your application's effective date, visit or contact ",
        serviceOntarioText: "ServiceOntario centre"
    },

    fr: {
        emailTitle: "Envoyez le reçu de la transaction à l’adresse suivante :",
        emailDescription: "Votre adresse ne servira qu’à l’envoi d’un reçu de transaction et ne sera pas conservée.",

        backToHome: "Retour à l'accueil",
        backToOntario: "Retour à Ontario.ca",

        alertTitle: "La carte Santé de l’enfant a été renouvelée.",
        confirmationReceiptBody: "Un message de confirmation sera envoyé à votre boîte de réception.",
        confirmationReceiptBodyForUser: "Un courriel de confirmation avec votre reçu a été envoyé à {{email}}",

        technicalIssueWarning: "En raison d'un problème technique, nous n'avons pas pu générer votre reçu téléchargeable. Veuillez conserver une trace de votre identifiant de transaction et contacter ServiceOntario si vous ne recevez pas la carte Santé dans un délai de 4 à 6 semaines.",

        pageTitle: "order-confirmation",
        saveReceiptTitle: "Enregistrez votre reçu de confirmation.",

        orderIdLabel: "Numéro de commande :",

        confirmationTextGuest: "Pour continuer à utiliser la carte Santé actuelle de votre enfant, vous pouvez télécharger une copie de la confirmation ou en envoyer une à votre courriel ci-dessous.",
        confirmationTextUser: "Un accusé de réception a été envoyé dans la boîte de réception de votre compte. Vous pouvez télécharger une copie de cette confirmation en guise de preuve. Vous pouvez aussi vous en servir avec la carte Santé de l’enfant actuelle jusqu’à l’arrivée de la nouvelle carte.",

        downloadPdfButton: "Télécharger l’accusé de réception (PDF)",

        importantNoticeGuest: "IMPORTANT : Vérifiez vos fichiers téléchargés avant de fermer la fenêtre. Vous ne pourrez plus accéder à votre accusé de réception ici.",
        importantNoticeUser: "IMPORTANT : Vérifiez vos fichiers téléchargés avant de fermer la fenêtre. Vous ne pourrez plus accéder à votre accusé de réception ici.",

        whatToDoNext: "À faire ensuite :",
        step1: "Si vous n’imprimez ou ne téléchargez pas votre document maintenant, vous devrez vous pointer dans un {{ServiceOntarioLink}} pour en demander une copie.",
        step2: "Une capture d’écran de la page n’est pas recevable comme preuve de renouvellement.",
        step3: "Vous devez conserver le document temporaire et le reçu avec la carte Santé actuelle de votre enfant jusqu’à la réception de la nouvelle carte.",
        step4: "La nouvelle carte Santé de l’enfant arrivera par la poste dans un délai de 4 à 6 semaines. Une fois que vous aurez reçu la carte Santé de votre enfant, vous devrez détruire l’ancienne carte Santé. Vous devrez aussi détruire votre document temporaire.",

        continueUsingCard: "Veuillez continuer d'utiliser la carte Santé existante de votre enfant jusqu'à la réception de la nouvelle par la poste. La carte renouvelée vous sera envoyée par la poste dans environ quatre à six semaines. Si vous n'avez pas reçu votre carte dans les six semaines suivant la date d'entrée en vigueur de votre demande, visitez ou contactez ",
        serviceOntarioText: "centre ServiceOntario"
    }
};

const getContent = (isEng: boolean) => {
    return CONTENT[isEng ? 'en' : 'fr'];
};

interface Props {
    programContainer: ProgramContainer
    isEng: boolean;
    transactionId: string;
    Visible: boolean;
    callback: (p: any) => void,
    uploadReceiptSuccess: boolean,
    renewalResponse: any
}

export class CHCOrderConfirmationComponent extends React.Component<Props> {
    field: FormSectionElements;

    constructor(props: Props) {
        super(props);

        this.field = new FormSectionElements();
        this.field.ENUTitle = CONTENT.en.emailTitle;
        this.field.FRATitle = CONTENT.fr.emailTitle;

        this.field.ENUDescription = CONTENT.en.emailDescription;
        this.field.FRADescription = CONTENT.fr.emailDescription;

        sessionStorage.removeItem("CHCSummaryFired");
    }

    //FIXME: Remove this later
    downloadReceipt(transId: string) {
        const url = getEnvVar('DOWNLOAD_RECEIPT_URL').replace("{transactionID}", transId);
        fetch(url).then(resp => resp.arrayBuffer())
            .then(buf => {
                const blob = new Blob([buf], {type: "application/pdf"});
                const anchor = document.createElement("a");

                anchor.href = window.URL.createObjectURL(blob);
                anchor.download = `Child health card renewal receipt`;
                anchor.hidden = true;

                document.body.append(anchor);
                anchor.click();
                anchor.remove();

                // in case the Blob uses a lot of memory
                window.addEventListener(
                    "focus",
                    () => {
                        URL.revokeObjectURL(anchor.href);
                    },
                    {
                        once: true,
                    }
                )
            });
    }

    downloadDocument() {
        if (!this.props?.renewalResponse?.receiptFile) {
            console.log('No file available to download');
            return;
        }
        const binaryString = atob(this.props.renewalResponse.receiptFile);
        const bytes = Uint8Array.from(binaryString, char => char?.charCodeAt(0));
        const blob = new Blob([bytes], {type: "application/pdf"});
        const anchor = document.createElement("a");

        anchor.href = window.URL.createObjectURL(blob);
        anchor.download = 'Child health card renewal receipt';
        anchor.hidden = true;

        document.body.append(anchor);
        anchor.click();
        anchor.remove();

        window.addEventListener(
            "focus",
            () => {
                URL.revokeObjectURL(anchor.href);
            },
            {
                once: true,
            }
        )
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
        if (!this.props.Visible) return;
        const title = "your-renewal-application-has-been-submitted"
        const isEng = window.location.href.indexOf("/fr/") == -1;

        let preUrl = window.location.origin + "/on-form/chc/review-your-information";
        if (!prevProps.isEng) {
            preUrl = window.location.origin + "/on-form/fr/chc/review-your-information";
        }

        sessionStorage.setItem("previousUrl", preUrl);

        let urlString = window.location.origin + "/on-form/chc/" + title;

        if (!isEng) {
            urlString = window.location.origin + "/on-form/fr/chc/" + title;
        }
        window.history.pushState({}, "", normalizeUrl(urlString));

        if (this.props.Visible && sessionStorage.getItem("languageChange") != "true"
            && sessionStorage.getItem("CHCSummaryFired") != "true") {
            TrackPageView(this.props.programContainer);
            sessionStorage.setItem("CHCSummaryFired", "true");
            sessionStorage.removeItem("languageChange")
        }
    }

    componentWillUnmount(): void {
        sessionStorage.removeItem("CHCSummaryFired");
        sessionStorage.removeItem("languageChange");
    }

    renderCHC1Flow() {
        const profile = this.props.programContainer.Profile;
        const data = DataUtils.collectFormValue(this.props.programContainer);
        const svcToken = this.props?.renewalResponse?.svcToken || data?.svcToken || '';

        const surveyUrlParams = {
            cxpuser: profile?.userId ? 'yes' : 'no',
            svc: data?.childAgeCategory === 'CAT-3' ? 'unval' : 'val',
            src: 'link',
            sts: '100',
            sglocale: this.props.isEng ? 'en' : 'fr-ca',
        }

        let backToLabel;
        let backToUrl;
        let body;
        if (profile && profile.email) {
            backToLabel = this.props.isEng ? "Back to home" : "Retour à l'accueil";
            backToUrl = getEnvVar('PUBLIC_CXP_WEB_BASE_PATH') + '/auth/signin?redirectUri=/web' + (this.props.isEng ? '' : '/fr') + '/dashboard';
            body = this.props.isEng ? "A confirmation receipt will be sent to your inbox." : "Un message de confirmation sera envoyé à votre boîte de réception."
        } else {
            backToLabel = this.props.isEng ? "Back to Ontario.ca" : "Revenir à Ontario.ca";
            backToUrl = this.props.isEng ? "https://www.ontario.ca/page/government-ontario" : "https://www.ontario.ca/fr/page/gouvernement-de-lontario";
        }

        const alertTitle = this.props.isEng ? "The child health card renewal application has been submitted"
            : "La demande de renouvellement de la carte Santé de l'enfant a été soumise";
        const isReceiptUploaded: boolean = this.props.uploadReceiptSuccess;

        return (
            <div>
                <div>
                    <StepIndicator withbackbtn={true} sectionSequence={-1}
                                   title={backToLabel}
                                   backToUrl={backToUrl}
                                   programContainer={this.props.programContainer}
                                   isEng={this.props.isEng}
                                   callback={(currentStep) => {
                                       this.setState({stepperIndex: currentStep})
                                   }}>
                    </StepIndicator>
                </div>

                <div>
                    {isReceiptUploaded ?
                        <SuccessAlertComponent field={this.field}
                                               title={alertTitle}
                                               bodyMsg={body}
                                               isEng={this.props.isEng} Visible={isReceiptUploaded}/>
                        :
                        <WarningAlertComponent title={alertTitle}
                                               bodyMsg={this.props.isEng ? "Due to a technical issue, we were unable to generate your downloadable receipt. Please keep a record of your order ID and contact ServiceOntario if you do not receive the health card in 4-6 weeks." : "En raison d'un problème technique, nous n'avons pas pu générer votre reçu téléchargeable. Veuillez conserver une trace de votre identifiant de transaction et contacter ServiceOntario si vous ne recevez pas la carte Santé dans un délai de 4 à 6 semaines."}
                                               isEng={this.props.isEng}
                                               Visible={!isReceiptUploaded}/>}

                </div>

                <div>
                    <span className="ontario-h1">{this.props.isEng ? "Your renewal application has been submitted" :
                        "La demande de renouvellement de la carte Santé de l'enfant a été soumise"}</span>
                </div>
                <p></p>
                <div>
                    <span className="ontario-h5">{this.props.isEng ? "Order ID: " + this.props.transactionId :
                        "ID de la commande :" + this.props.transactionId}</span>
                </div>
                <p></p>
                <div>
                    <button className="ontario-button ontario-button--primary confirmation-button"
                            disabled={!isReceiptUploaded}
                            onClick={() => this.downloadDocument()}>
                        {this.props.isEng ? "Download PDF confirmation" : "Télécharger la confirmation en PDF"}
                    </button>
                </div>
                <div>
                    <button className="ontario-button ontario-button--secondary confirmation-button" onClick={() => {
                        window.location.replace(backToUrl);
                    }}>
                        {backToLabel}
                    </button>
                </div>
                <div style={{display: 'flex', alignItems: 'flex-start'}} className="ontario-margin-bottom-32-!">
                    <AlertIcon style={{width: '36px', height: '36px', marginRight: '0.5rem', marginTop: '-0.25rem'}}/>
                    {this.props.isEng && !this.props.programContainer.Profile?.userId && (
                        <span>IMPORTANT: Check your downloaded files before closing this screen. You will not be able to access your confirmation here again.</span>
                    )}
                    {this.props.isEng && this.props.programContainer.Profile?.userId && (
                        <span>Note: Check your downloaded files before closing this screen.</span>
                    )}
                    {!this.props.isEng && !this.props.programContainer.Profile?.userId && (
                        <span>IMPORTANT : Vérifiez vos fichiers téléchargés avant de fermer cet écran. Vous ne pourrez plus accéder à votre confirmation ici.</span>
                    )}
                    {!this.props.isEng && this.props.programContainer.Profile?.userId && (
                        <span>Remarque : Vérifiez vos fichiers téléchargés avant de fermer cet écran.</span>
                    )}
                </div>
                <div>
                    <div style={{
                        display: profile && profile.userId ? "none" : "block", ...(!isReceiptUploaded && {
                            pointerEvents: 'none',
                            opacity: 0.5
                        })
                    }}>
                        <EmailButtonComponent key={"EmailComponent"}
                                              field={this.field} editable={true}
                                              disabled={!isReceiptUploaded}
                                              title={this.props.isEng ? <Heading5>{this.field.ENUTitle}</Heading5> :
                                                  <Heading5>{this.field.FRATitle}</Heading5>}
                                              labelControlArray={null} requiredField={false}
                                              isEng={this.props.isEng}
                                              callback={(field) => {
                                                  console.log(field)
                                                  const payload = {
                                                      "to": field.Value,
                                                      "transactionId": this.props.transactionId,
                                                      "language": this.props.isEng ? "EN" : "FR",
                                                      "category": data?.childAgeCategory || '',
                                                      "expireDate": data?.childHealthCardExpiryDate || '',
                                                      "hcVersion": data?.childCardNumber.slice(-2) || '',
                                                      "svcToken": svcToken
                                                  }
                                                  const url = getEnvVar('EMAIL_URL');
                                                  axios.post(url, payload)
                                                      .then(
                                                          (res) => {
                                                              console.log(res)
                                                          }
                                                      )
                                                      .catch(ex => {
                                                          console.log(ex);
                                                      })
                                              }}>
                        </EmailButtonComponent>
                    </div>

                    <div>
                        <p></p>
                        <span className="ontario-h2">{this.props.isEng ? "What to do next" : "Que faire ensuite"}</span>
                    </div>
                    <div>
                        <ul>
                            <li>{this.props.isEng ? "keep your receipt" : "Conservez votre reçu"}</li>
                            <li>{this.props.isEng ? "Please continue to use your child's existing health card until the process is completed. If the application is successful, the renewed card will be mailed to you in approximately 4 to 6 weeks. If you do not receive your card within 6 weeks of your application's effective date, visit or contact "
                                : "Veuillez continuer d'utiliser la carte Santé existante de votre enfant jusqu'à la réception de la nouvelle par la poste. La carte renouvelée vous sera envoyée par la poste dans environ quatre à six semaines. Si vous n'avez pas reçu votre carte dans les six semaines suivant la date d'entrée en vigueur de votre demande, visitez ou contactez "}
                                <a href={this.props.isEng ? "https://www.ontario.ca/page/government-ontario" : "https://www.ontario.ca/fr/page/gouvernement-de-lontario"}>ServiceOntario</a>.
                            </li>
                        </ul>
                    </div>
                    <div>
                        <FeedbackComponent
                            programContainer={this.props.programContainer}
                            isEng={this.props.isEng}
                            transactionId={this.props.transactionId}
                            status={FeedbackStatus.Success}
                            isHyperlink={true}
                            params={surveyUrlParams}
                        />
                    </div>
                </div>
            </div>
        )
    }

    renderCHC2Flow() {
        const content = getContent(this.props.isEng);
        const profile = this.props.programContainer.Profile;
        const data = DataUtils.collectFormValue(this.props.programContainer);
        const svcToken = this.props?.renewalResponse?.svcToken || data?.svcToken || '';

        const surveyUrlParams = {
            cxpuser: profile?.userId ? 'yes' : 'no',
            svc: data?.childAgeCategory === 'CAT-3' ? 'unval' : 'val',
            src: 'link',
            sts: '100',
            sglocale: this.props.isEng ? 'en' : 'fr-ca',
        }

        let backToLabel;
        let backToUrl;
        let body;
        if (profile?.email) {
            backToLabel = content.backToHome;
            backToUrl = getEnvVar('PUBLIC_CXP_WEB_BASE_PATH') + '/auth/signin?redirectUri='
                + (this.props.isEng ? '' : '/fr') + '/dashboard';
            body = content.confirmationReceiptBodyForUser.replace("{{email}}", profile.email);
        } else {
            backToLabel = content.backToOntario;
            backToUrl = this.props.isEng ? "https://www.ontario.ca/page/government-ontario"
                : "https://www.ontario.ca/fr/page/gouvernement-de-lontario";
        }

        const alertTitle = content.alertTitle;
        const isReceiptUploaded: boolean = this.props.uploadReceiptSuccess;

        return (
            <div>
                <div>
                    <StepIndicator
                        withbackbtn={true}
                        sectionSequence={-1}
                        title={backToLabel}
                        programContainer={this.props.programContainer}
                        isEng={this.props.isEng}
                        callback={(currentStep) => {
                            this.setState({stepperIndex: currentStep})
                        }}>
                    </StepIndicator>
                </div>

                <div>
                    {isReceiptUploaded ?
                        <SuccessAlertComponent
                            field={this.field}
                            title={alertTitle}
                            bodyMsg={body}
                            isEng={this.props.isEng} Visible={isReceiptUploaded}/>
                        :
                        <WarningAlertComponent
                            title={alertTitle} bodyMsg={content.technicalIssueWarning}
                            isEng={this.props.isEng}
                            Visible={!isReceiptUploaded}/>}

                </div>

                <div>
                    <h1>{content.saveReceiptTitle}</h1>
                    <p>{content.orderIdLabel}{this.props.transactionId}</p>
                    <p>{profile?.userId ? content.confirmationTextUser
                        : content.confirmationTextGuest}
                    </p>
                </div>

                <div>
                    <button
                        className="ontario-button ontario-button--primary confirmation-button"
                        disabled={!isReceiptUploaded}
                        onClick={() => this.downloadDocument()}>
                        {content.downloadPdfButton}
                    </button>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'start',
                        gap: '0.5rem',
                        marginBottom: '2.5rem'
                    }}
                >
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <AlertIcon style={{width: '24px', height: '24px'}}/>
                    </div>
                    <span>
                        {!this.props.programContainer.Profile?.userId ? content.importantNoticeGuest
                            : content.importantNoticeUser}
                    </span>
                </div>
                <div>
                    <div
                        style={{
                            display: profile && profile.userId ? "none" : "block",
                            ...(!isReceiptUploaded && {
                                pointerEvents: 'none',
                                opacity: 0.5
                            })
                        }}>
                        <EmailButtonComponent
                            key={"EmailComponent"}
                            field={this.field} editable={true}
                            disabled={!isReceiptUploaded}
                            title={this.props.isEng ? <Heading5>{this.field.ENUTitle}</Heading5> :
                                <Heading5>{this.field.FRATitle}</Heading5>}
                            labelControlArray={null} requiredField={false}
                            isEng={this.props.isEng}
                            callback={(field) => {
                                console.log(field)
                                const payload = {
                                    "to": field.Value,
                                    "transactionId": this.props.transactionId,
                                    "language": this.props.isEng ? "EN" : "FR",
                                    "category": data?.childAgeCategory || '',
                                    "expireDate": data?.childHealthCardExpiryDate || '',
                                    "hcVersion": data?.childCardNumber.slice(-2) || '',
                                    "svcToken": svcToken
                                }
                                const url = getEnvVar('EMAIL_URL');
                                axios.post(url, payload)
                                    .then(
                                        (res) => {
                                            console.log(res)
                                        }
                                    )
                                    .catch(ex => {
                                        console.log(ex);
                                    })
                            }}>
                        </EmailButtonComponent>
                    </div>

                    <div>
                        <h2> {content.whatToDoNext}</h2>
                    </div>
                    <div>
                        <ul>
                            <li>
                                {(() => {
                                    const parts = content.step1.split("{{ServiceOntarioLink}}");
                                    return (
                                        <>
                                            {parts[0]}
                                            <a
                                                target={"_blank"}
                                                rel="noopener noreferrer"
                                                href={this.props.isEng ? "https://www.ontario.ca/page/book-serviceontario-appointment"
                                                    : "https://www.ontario.ca/fr/page/prendre-un-rendez-vous-serviceontario"}>
                                                {content.serviceOntarioText}
                                            </a>
                                            {parts[1]}
                                        </>
                                    );
                                })()}
                            </li>
                            <li>
                                {content.step2}
                            </li>
                            <li>
                                {content.step3}
                            </li>
                            <li>
                                {content.step4}
                            </li>
                        </ul>
                    </div>

                    <div>
                        <FeedbackComponent
                            programContainer={this.props.programContainer}
                            isEng={this.props.isEng}
                            transactionId={this.props.transactionId}
                            status={FeedbackStatus.Success}
                            isHyperlink={true}
                            params={surveyUrlParams}
                        />
                    </div>

                    <Divider/>

                    <section>
                        <AvailableServicesComponent isEng={this.props.isEng}/>
                    </section>
                </div>
            </div>
        )
    }

    render() {
        if (!this.props.Visible) return null;

        const data = DataUtils.collectFormValue(this.props.programContainer);

        // Renders the CHC 2 flow only when the childAgeCategory is 'CAT-15', otherwise renders the CHC 1 flow
        if (data?.childAgeCategory === 'CAT-15') {
            return this.renderCHC2Flow();
        } else {
            return this.renderCHC1Flow();
        }
    }
}

const CARDS_CONTENT = {
    en: [
        {
            id: 1,
            title: "Create an account",
            description: "You're a few clicks away from creating an account. Create an account to complete services faster in the future.",
            image: createAccount
        },
        {
            id: 2,
            title: "Renewal reminders",
            description: "Get reminders before your licence plate, driver's licence, health card, or Ontario photo card expires.",
            image: renewalReminders
        },
        {
            id: 3,
            title: "Explore more services",
            description: "Check out other services you can complete easily from the comfort of your own home.",
            image: moreServices
        }
    ],
    fr: [
        {
            id: 1,
            title: "Créer un compte",
            description: "Vous n'êtes qu'à quelques clics de la création d'un compte. Créez un compte pour effectuer vos démarches plus rapidement à l'avenir.",
            image: createAccount
        },
        {
            id: 2,
            title: "Rappels de renouvellement",
            description: "Recevez des rappels avant l'expiration de votre plaque d'immatriculation, permis de conduire, carte Santé ou carte-photo de l'Ontario.",
            image: renewalReminders
        },
        {
            id: 3,
            title: "Explorer plus de services",
            description: "Découvrez d'autres services que vous pouvez effectuer facilement dans le confort de votre foyer.",
            image: moreServices
        }
    ]
};


const CardsContainer = styled.div`
    display: flex;
    gap: 24px;
    align-items: flex-start;
    flex-direction: column;

    @media (min-width: 768px) {
        flex-direction: row;
    }
`;

const Card = styled.div`
    width: 357.33px;
    height: 342px;
    border-radius: 4px;
    background-color: white;
    box-shadow: 0px 3px 8px 1px #00000066;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

const ImageContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const Content = styled.div`
    padding: 24px;
    min-height: 140px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    font-family: 'Raleway', sans-serif;
`;

const Link = styled.a`
    font-family: Raleway, "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 700;
    font-size: 19px;
    line-height: 29px;
    letter-spacing: 0.4px;
    vertical-align: middle;
    text-decoration: underline;
    color: #0066CC;
    margin-bottom: 8px;
`;

const Description = styled.p`
    font-weight: 400;
    font-size: 16px;
    color: #1A1A1A;
    line-height: 1.5;
    margin: 0;
`;


const AvailableServicesComponent: React.FC<{ isEng: boolean }> = ({isEng}) => {
        const cards = CARDS_CONTENT[isEng ? 'en' : 'fr'];
        useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
        return (
            <CardsContainer>
                {cards.map((card) => (
                    <Card
                        key={card.id}>

                        <ImageContainer>
                            <Image
                                src={card.image}
                                alt={card.title}
                            />
                        </ImageContainer>

                        <Content>
                            <Link
                                href="https://www.ontario.ca/page/government-ontario"
                                target={"_blank"}>
                                {card.title}
                            </Link>
                            <Description>
                                {card.description}
                            </Description>
                        </Content>
                    </Card>
                ))}
            </CardsContainer>
        );
    }
;